import { IApplicationState } from '../../types/redux';
import { INewbuildingProblemSchema } from '../../repositories/newbuilding-card/entities/newbuilding/NewbuildingProblemSchema';

export function getProblems(state: IApplicationState): INewbuildingProblemSchema[] {
  const {
    newbuilding: { problems },
  } = state;

  if (!problems) {
    return [];
  }

  return problems;
}
